export default __webpack_public_path__ + "static/media/bg.b73e45b0.jpeg";